export { AccordionHeader } from './accordion-header';
export type { AccordionHeaderProps } from './types';
